import { useEffect, useRef } from 'react'
import { marked } from 'marked'
import type { Message } from '../stores/chatStore'

marked.setOptions({ breaks: true, gfm: true })

function Markdown({ content }: { content: string }) {
  const html = marked.parse(content) as string
  return <div className="markdown" dangerouslySetInnerHTML={{ __html: html }} />
}

export default function ChatView({ messages, streaming }: { messages: Message[]; streaming: boolean }) {
  const bottomRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages.length])

  if (messages.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center text-gray-500">
          <div className="text-4xl mb-4">🤖</div>
          <div className="text-lg font-medium mb-2 text-white">The Italian Job</div>
          <div className="text-sm">Start a conversation with Hermes 4 70B</div>
        </div>
      </div>
    )
  }

  return (
    <div className="flex-1 overflow-y-auto px-4">
      <div className="max-w-3xl mx-auto py-4 space-y-6">
        {messages.map((msg, i) => (
          <div key={msg.id} className={`flex gap-4 ${msg.role === 'user' ? 'justify-end' : ''}`}>
            {msg.role === 'assistant' && (
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">AI</div>
            )}
            <div className={`max-w-[85%] rounded-2xl px-4 py-3 text-sm leading-relaxed ${msg.role === 'user' ? 'bg-gray-800 text-white rounded-br-md' : 'text-gray-200'}`}>
              {msg.role === 'assistant' ? <Markdown content={msg.content} /> : <div className="whitespace-pre-wrap">{msg.content}</div>}
              {streaming && msg.role === 'assistant' && i === messages.length - 1 && <span className="cursor-blink" />}
            </div>
            {msg.role === 'user' && (
              <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">U</div>
            )}
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
    </div>
  )
}
